import { render } from "./Survey.vue?vue&type=template&id=348a55e4&scoped=true"
import script from "./Survey.vue?vue&type=script&lang=js"
export * from "./Survey.vue?vue&type=script&lang=js"

import "./Survey.vue?vue&type=style&index=0&id=348a55e4&scoped=true&lang=css"

import exportComponent from "D:\\eazyc\\ezDev\\ECS-Cognitive\\cognitive-screening-mobile-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-348a55e4"]])

export default __exports__